<ng-container *ngIf="activeTrackingKeywordCount === 0; else showTrackingKeywords">
  <div class="row">
    <div class="col-md-12">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>
              Tracking Keywords
              <i *ngIf="readOnlyReasons" class="fas fa-lock text-danger ms-2" triggers="mouseenter:mouseleave" [ngbPopover]="readOnlyReasons"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>No tracking keywords have been defined yet</td>
          </tr>
          <tr>
            <td>
              <div class="row">
                <div class="col-12">
                  <app-components-shared-add-keyword
                    [customer]="customer"
                    [websiteUrls]="websiteUrls"
                    [trackingKeywords]="trackingKeywords"
                    [archivedKeywords]="archivedKeywords"
                    [restrictions]="restrictions"
                    [keywordConfig]="keywordConfig">
                  </app-components-shared-add-keyword>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>
<ng-template #showTrackingKeywords>
  <div class="row">
    <div class="col-md-12">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>
              Tracking Keywords
              <i *ngIf="readOnlyReasons" class="fas fa-lock text-danger ms-2" triggers="mouseenter:mouseleave" [ngbPopover]="readOnlyReasons"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let trackingKeyword of trackingKeywords">
            <ng-container *ngIf="trackingKeyword.IsActive">
              <tr>
                <td>
                  <app-components-shared-tracking-keyword
                    [customer]="customer"
                    [trackingKeyword]="trackingKeyword"
                    [websiteUrls]="websiteUrls"
                    [trackingKeywords]="trackingKeywords"
                    [archivedKeywords]="archivedKeywords"
                    [restrictions]="restrictions">
                  </app-components-shared-tracking-keyword>
                </td>
              </tr>
            </ng-container>
          </ng-container>
          <tr>
            <td>
              <div class="row">
                <div class="col-12">
                  <app-components-shared-add-keyword
                    [customer]="customer"
                    [websiteUrls]="websiteUrls"
                    [trackingKeywords]="trackingKeywords"
                    [archivedKeywords]="archivedKeywords"
                    [restrictions]="restrictions"
                    [keywordConfig]="keywordConfig">
                  </app-components-shared-add-keyword>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
